import { AssetCategory } from '../entities/AssetCategory';
import { SermonTemplate } from '../entities/SermonTemplate';
import { WebClient } from './server/WebClient';

export const SermonTemplateService = {
    getAll: () => WebClient.Get<SermonTemplate[]>("api/SermonTemplate/GetSermonTemplates"),
    getAllEnabled: () => WebClient.Get<SermonTemplate[]>("api/SermonTemplate/GetEnabledSermonTemplates"),
    purchase: (id: number) => WebClient.Put.Unvalidated<void>(`api/SermonTemplate/Purchase/`, {id}),
    activate: (id: number, name: string, category: AssetCategory) => WebClient.Post.Validated<string>(`api/SermonTemplate/Activate/`, {
        sermonTemplateId: id,
        name: name,
        category: category
    })
}